import { useMemo } from 'react';

import type { RoverBrandContextType } from '@rover/types/src/RoverBrand';
import { RoverBrand } from '@rover/types/src/RoverBrand';

export const useRoverBrandProvider = (brand: RoverBrand): RoverBrandContextType => {
  return useMemo(() => {
    const isCatInAFlat: boolean = brand === RoverBrand.CatInAFlat;
    const isRover: boolean = brand === RoverBrand.Rover;

    return { brand, isCatInAFlat, isRover };
  }, [brand]);
};
